// Turning a membership's auto-renew on or off after the sale (memberships.setAutoRenew, F-27): on
// needs the plan's terms shown word for word and the customer's yes, as selling does (renewalConsent
// in model.ts); off needs only the office's confirmation. Both are recorded, and the customer is
// sent their copy; the screen says whether it went.

import type { Renewal } from './model.ts';

/** setAutoRenew's renewal: model.ts's, with the customer's copy of the consent or the withdrawal. */
export type RenewalWithCopy = Renewal & { copy?: { sent: boolean; reason: string | null } | null };

/** What turning it off does, said first. */
export const offOutcome =
  'It won’t renew by itself: the office asks the customer to renew when the term ends. Nothing already paid changes.';

/** What the office is told after the change, with whether the customer's copy went out. */
export function autoRenewSaid(on: boolean, r: RenewalWithCopy): string {
  const head = on
    ? `Auto-renew is on, with the customer’s consent recorded.${r.notice ? ` ${r.notice}` : ''}`
    : 'Auto-renew is off: the office asks them to renew.';
  const copy = r.copy
    ? r.copy.sent
      ? ' Their copy was sent.'
      : ` Their copy wasn’t sent${r.copy.reason ? `: ${r.copy.reason}` : ''}. Give it to them another way.`
    : '';
  return head + copy;
}
